import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10 .001C4.5.001 0 4.398 0 9.775c0 7.234 9.1 13.295 9.4 13.49.2.098.4.196.6.196s.4-.098.6-.195c.3-.196 9.4-6.257 9.4-13.491C20 4.399 15.5 0 10 0zm0 21.31c-1.9-1.368-8-6.256-8-11.535 0-4.301 3.6-7.82 8-7.82s8 3.519 8 7.82c0 5.279-6.1 10.167-8 11.535m0-15.445c-2.2 0-4 1.76-4 3.91s1.8 3.91 4 3.91 4-1.76 4-3.91-1.8-3.91-4-3.91m0 5.865c-1.1 0-2-.88-2-1.955s.9-1.955 2-1.955 2 .88 2 1.955-.9 1.955-2 1.955"
    }, null, -1)
  ]))]))
}
export default { render: render }